class MetanavBase extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.metanav__item--has-submenu');

    this.items.forEach((item) => {
      const link = item.querySelector('.metanav__link');
      const dropdown = item.querySelector('.metanav__dropdown');
      if (!link || !dropdown) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(item._closeTimer);
        link.setAttribute('aria-expanded', 'true');
        this.items.forEach((other) => {
          if (other !== item) {
            clearTimeout(other._closeTimer);
            const otherLink = other.querySelector('.metanav__link');
            if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
          }
        });
      });

      item.addEventListener('mouseleave', (e) => {
        const to = e.relatedTarget;
        if (to && (item.contains(to) || to.closest('.metanav__dropdown') === dropdown)) return;
        item._closeTimer = setTimeout(() => {
          link.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      dropdown.addEventListener('mouseenter', () => {
        clearTimeout(item._closeTimer);
      });

      dropdown.addEventListener('mouseleave', (e) => {
        const to = e.relatedTarget;
        if (to && (item.contains(to) || dropdown.contains(to))) return;
        item._closeTimer = setTimeout(() => {
          link.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const expanded = link.getAttribute('aria-expanded') === 'true';
          this.closeAll();
          if (!expanded) link.setAttribute('aria-expanded', 'true');
        }
        if (e.key === 'Escape') {
          this.closeAll();
          link.focus();
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeAll();
    });
  }

  closeAll() {
    this.querySelectorAll('.metanav__link[aria-expanded="true"]').forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
    });
  }
}

class MetanavLeft extends MetanavBase {}
class MetanavRight extends MetanavBase {}

customElements.define('metanav-left', MetanavLeft);
customElements.define('metanav-right', MetanavRight);

// Mobile accordion
document.querySelectorAll('.metanav-mobile__toggle').forEach((btn) => {
  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const submenu = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(!expanded));
    if (submenu) submenu.hidden = expanded;
  });
});

// 透明导航控制
const header = document.getElementById('header-component');
if (header) {
  header.addEventListener('mouseenter', () => {
    header.classList.add('header--nav-hover');
  });

  header.addEventListener('mouseleave', (e) => {
    const to = e.relatedTarget;
    if (to && header.contains(to)) return;
    header.classList.remove('header--nav-hover');
  });


}
